<template>
  <div class="vx-mask" v-if="show" @click="close" touchmove="true" :style="{ 'z-index': zindex  }">
    <slot></slot>
  </div>
</template>
<script>
import {
  mapGetters,
  mapActions
} from 'vuex';

export default {
  name: 'YDMask',
  data() {
    return {
      show: this.value
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    bgcolor: {
      type: String,
      default: '#000'
    },
    zindex: {
      default: 3
    },
    opacity: {
      default: .5
    },
    animated: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    value(val) {
      this.show = val;
      if (val) {
        this.setPageLock(true)
      } else {
        this.setPageLock(false)
      }
    }
  },
  mounted() {
    if (this.value) {
      this.setPageLock(true)
    }
  },
  beforeDestroy() {

  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    close() {
      this.$emit('input', false);
      this.$emit('close', false);
      this.setPageLock(false)
    }
  }
}
</script>
<style lang="less">
@import './index.less';
</style>